export const SMALL_SIDEBAR_SECTION_HEIGHT = 75;
export const MAIN_CONTENT_PADDING = 24;
